export default {
  title: 'HubRise',
  setup: {
    description: 'Udostępniaj dane innym aplikacjom.',
  },
  form: {
    is_menus_sync_enabled: 'Synchronizuj menu',
    is_inventory_sync_enabled: 'Synchronizuj stan magazynowy',
    is_opening_hours_sync_enabled: 'Synchronizuj godziny otwarcia',
    is_order_acceptance_mode_sync_enabled: 'Synchronizuj status zajęty / wstrzymany',
    variant_ref: 'Wariant menu',
    variant_ref_default: 'Domyślny',
  },
  tabs: {
    settings: 'Ustawienia',
    service_types: 'Typy usług',
    payments: 'Płatności',
    charges: 'Opłaty',
    deals: 'Oferty',
    discounts: 'Rabaty',
    customers: 'Klienci',
  },
  customers: {
    description:
      'Usuń dane jednego klienta po stronie HubRise, np. na żądanie usunięcia danych. Tej operacji nie można cofnąć.',
    customer: 'Klient',
    placeholder: 'Szukaj po nazwie, e-mailu lub telefonie…',
  },
  mapping: {
    description:
      'Przypisz każdy element {{provider}} do odpowiedniej wartości i nazwy HubRise. Pozostaw wiersz pusty, aby użyć domyślnych wartości {{provider}}.',
    entity: '{{provider}}',
    value: 'Wartość HubRise',
    name: 'Nazwa HubRise',
  },
  connecting: {
    title: 'Kończenie połączenia z HubRise…',
    description: 'To potrwa kilka sekund. Nie zamykaj tej strony.',
    error_title: 'Połączenie z HubRise trwa dłużej niż oczekiwano',
    error_description:
      'HubRise zostało autoryzowane, ale połączenie nie zostało jeszcze potwierdzone. Sprawdź ponownie za chwilę — jeśli problem nie ustępuje, rozpocznij połączenie od nowa.',
  },
  buttons: {
    connect: 'Połącz z HubRise',
    check_again: 'Sprawdź ponownie',
    disconnect: 'Rozłącz',
    go_to_hubrise: 'Przejdź do HubRise',
    pull_menus: 'Pobierz menu',
    pull_inventory: 'Pobierz stan magazynowy',
    save: 'Zapisz',
    delete_customer: 'Usuń klienta',
  },
  toasts: {
    connected: 'HubRise zostało połączone',
    connect_cancelled: 'Połączenie z HubRise zostało anulowane',
    connect_error: 'Nie udało się nawiązać połączenia z HubRise',
    connect_timeout: 'Połączenie z HubRise nie zostało jeszcze potwierdzone',
    local_changes_replaced:
      'Ustawienia HubRise zostały zaktualizowane w innym miejscu — niezapisane zmiany zostały zastąpione',
    disconnect_success: 'HubRise zostało rozłączone',
    disconnect_error: 'Nie udało się rozłączyć HubRise',
    pull_menus_success: 'Synchronizacja menu została uruchomiona',
    pull_menus_error: 'Nie udało się pobrać menu',
    pull_inventory_success: 'Synchronizacja stanu magazynowego została uruchomiona',
    pull_inventory_error: 'Nie udało się pobrać stanu magazynowego',
    save_success: 'Ustawienia HubRise zostały zapisane',
    save_error: 'Nie udało się zapisać ustawień HubRise',
    load_customers_error: 'Nie udało się załadować klientów',
    delete_customer_success: 'Żądanie usunięcia danych klienta zostało wysłane',
    delete_customer_error: 'Nie udało się usunąć danych klienta',
  },
  delete_customer_confirm: {
    title: 'Usunąć tego klienta z HubRise?',
    description: 'Dane klienta zostaną usunięte po stronie HubRise. Tej operacji nie można cofnąć.',
    ok: 'Usuń',
    cancel: 'Anuluj',
  },
  disconnect_confirm: {
    title: 'Rozłączyć HubRise?',
    description: 'Spowoduje to zatrzymanie synchronizacji menu, zapasów i zamówień z HubRise.',
    ok: 'Rozłącz',
    cancel: 'Anuluj',
  },
  connected: {
    title: 'Połączono z HubRise',
    description: 'Twoje konto HubRise zostało pomyślnie powiązane.',
    account: 'Konto',
    location: 'Lokalizacja',
    catalog: 'Katalog',
    customer_list: 'Lista klientów',
  },
};
